import { render, staticRenderFns } from "./TributeRenderPanelSuper.vue?vue&type=template&id=0cdd2398"
import script from "./TributeRenderPanelSuper.vue?vue&type=script&lang=js"
export * from "./TributeRenderPanelSuper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports